import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

// Staff management actions
export const create_staff = createAsyncThunk(
    'staff/create_staff',
    async (staffData, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/admin/staff', staffData, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_all_staff = createAsyncThunk(
    'staff/get_all_staff',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/admin/staff', { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_staff_details = createAsyncThunk(
    'staff/get_staff_details',
    async (id, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/admin/staff/${id}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const update_staff = createAsyncThunk(
    'staff/update_staff',
    async ({ id, staffData }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put(`/admin/staff/${id}`, staffData, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const reset_staff_password = createAsyncThunk(
    'staff/reset_staff_password',
    async (id, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(`/admin/staff/${id}/reset-password`, {}, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const deactivate_staff = createAsyncThunk(
    'staff/deactivate_staff',
    async (id, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put(`/admin/staff/${id}/deactivate`, {}, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const activate_staff = createAsyncThunk(
    'staff/activate_staff',
    async (id, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put(`/admin/staff/${id}/activate`, {}, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const delete_staff = createAsyncThunk(
    'staff/delete_staff',
    async (id, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.delete(`/admin/staff/${id}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_staff_navigation = createAsyncThunk(
    'staff/get_staff_navigation',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/admin/staff-navigation', { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const staffReducer = createSlice({
    name: 'staff',
    initialState: {
        successMessage: '',
        errorMessage: '',
        loader: false,
        staffList: [],
        currentStaff: null,
        newStaffCredentials: null,
        staffNavigation: []
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = ""
            state.successMessage = ""
        },
        clearStaffCredentials: (state, _) => {
            state.newStaffCredentials = null
        }
    },
    extraReducers: {
        [create_staff.pending]: (state, _) => {
            state.loader = true
        },
        [create_staff.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        },
        [create_staff.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
            state.staffList.push(payload.staff)
            state.newStaffCredentials = payload.loginCredentials
        },
        [get_all_staff.pending]: (state, _) => {
            state.loader = true
        },
        [get_all_staff.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        },
        [get_all_staff.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.staffList = payload.staff
        },
        [get_staff_details.pending]: (state, _) => {
            state.loader = true
        },
        [get_staff_details.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        },
        [get_staff_details.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.currentStaff = payload.staff
        },
        [update_staff.pending]: (state, _) => {
            state.loader = true
        },
        [update_staff.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        },
        [update_staff.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
            const index = state.staffList.findIndex(staff => staff._id === payload.staff._id)
            if (index !== -1) {
                state.staffList[index] = payload.staff
            }
            state.currentStaff = payload.staff
        },
        [reset_staff_password.pending]: (state, _) => {
            state.loader = true
        },
        [reset_staff_password.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        },
        [reset_staff_password.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
            state.newStaffCredentials = payload.loginCredentials
        },
        [deactivate_staff.pending]: (state, _) => {
            state.loader = true
        },
        [deactivate_staff.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        },
        [deactivate_staff.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
        },
        [activate_staff.pending]: (state, _) => {
            state.loader = true
        },
        [activate_staff.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        },
        [activate_staff.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
        },
        [delete_staff.pending]: (state, _) => {
            state.loader = true
        },
        [delete_staff.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        },
        [delete_staff.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
        },
        [get_staff_navigation.fulfilled]: (state, { payload }) => {
            state.staffNavigation = payload.navigation
        }
    }
})

export const { messageClear, clearStaffCredentials } = staffReducer.actions
export default staffReducer.reducer
